import initFirebase from '../../firebase';

export class BaseApi {
    protected db: firebase.firestore.Firestore = initFirebase().firestore();
}
